/* Stickerheads search terms: log completed search results once per visit. No visitor identity stored. */
(function(){
 if(!/^\/search(?:\/|$)/.test(location.pathname))return;
 var params=new URLSearchParams(location.search);
 var raw=params.get('sh_q')||params.get('q')||'';
 raw=raw.replace(/title:/gi,'').replace(/\s+AND\s+/gi,' ').replace(/["']/g,'').replace(/\s+/g,' ').trim();
 if(raw.length<2)return;
 var key='sh-search-recorded:'+location.pathname+':'+raw.toLowerCase();
 try{if(sessionStorage.getItem(key))return;sessionStorage.setItem(key,'1')}catch(e){}
 function record(){
 var count=null;
 var candidates=document.querySelectorAll('[data-search-results-count],[data-results-count]');
 for(var i=0;i<candidates.length;i++){var n=Number(candidates[i].getAttribute('data-search-results-count')||candidates[i].getAttribute('data-results-count'));if(Number.isInteger(n)&&n>=0){count=n;break}}
 var payload={query:raw,result_count:count};
 fetch('https://zktwaaoonagjtxbmvusx.supabase.co/functions/v1/stickerheads-search-log',{method:'POST',mode:'cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),keepalive:true}).catch(function(){try{sessionStorage.removeItem(key)}catch(e){}});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',record,{once:true});else record();
})();